import { Point, resolve } from '@compass/types/maps/Point';
import json from './helm.json';

const helm: Record<string, Point[]> = {};

for (const point of json) {
  const resolved = resolve(point);
  if (resolved.map !== 'no_map') {
    helm[resolved.map] ??= [];
    helm[resolved.map].push(resolved);
  }
}

export function getHelmFor(map: string): Point[] {
  return helm[map] ?? [];
}
